import api from './api';

// Countries
const getCountries = () => api.get('/location/countries/');
const getCountry = (countryId) => api.get(`/location/countries/${countryId}/`);
const createCountry = (data) => api.post('/location/countries/', data);
const updateCountry = (countryId, data) => api.put(`/location/countries/${countryId}/`, data);
const deleteCountry = (countryId) => api.delete(`/location/countries/${countryId}/`);

// States
const getStates = () => api.get('/location/states/');
const getState = (stateId) => api.get(`/location/states/${stateId}/`);
const createState = (data) => api.post('/location/states/', data);
const updateState = (stateId, data) => api.put(`/location/states/${stateId}/`, data);
const deleteState = (stateId) => api.delete(`/location/states/${stateId}/`);

// Cities
const getCities = () => api.get('/location/cities/');
const getCity = (cityId) => api.get(`/location/cities/${cityId}/`);
const createCity = (data) => api.post('/location/cities/', data);
const updateCity = (cityId, data) => api.put(`/location/cities/${cityId}/`, data);
const deleteCity = (cityId) => api.delete(`/location/cities/${cityId}/`);

// Location
const getLocations = () => api.get('/location/locations/');
const getLocation = (locationId) => api.get(`/location/locations/${locationId}/`);
const createLocation = (data) => api.post('/location/locations/', data);
const updateLocation = (locationId, data) => api.put(`/location/locations/${locationId}/`, data);
const deleteLocation = (locationId) => api.delete(`/location/locations/${locationId}/`);


export {
    getCountries,
    getCountry,
    createCountry,
    updateCountry,
    deleteCountry,
    getStates,
    getState,
    createState,
    updateState,
    deleteState,
    getCities,
    getCity,
    createCity,
    updateCity,
    deleteCity,
    getLocations,
    getLocation,
    createLocation,
    updateLocation,
    deleteLocation,
};
